import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps} from 'react-router-dom';
import {Button, Col, Label, Row, Table} from 'reactstrap';
import {AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';
import {IRootState} from 'app/shared/reducers';
import {useRegionLabels} from 'app/shared/hooks/useRegionLabels';
import {RegionDescriptionType} from 'app/shared/model/enumerations/region-description-type.model';
import {getPayments, getPaymentsByDriverName, getPaymentsByFilter, searchByPaymentId} from './payment.reducer';
import {PaymentStatus} from "app/shared/model/enumerations/payment-status.model";
import {convertDateTimeFromServer} from 'app/shared/util/date-utils';
import {fromCents} from 'app/shared/util/money-utils';
import {getSortState, JhiItemCount, JhiPagination} from 'react-jhipster';
import {overridePaginationStateWithQueryParams} from 'app/shared/util/entity-utils';
import {ITEMS_PER_PAGE} from 'app/shared/util/pagination.constants';
import {hasAnyPermission} from 'app/shared/auth/permissions';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import axios from 'axios';
import Loader from "react-loader-spinner";
import {getAllByType} from 'app/entities/region/region.reducer';
import {getHealthcareFacilitiesCompact} from 'app/entities/healthcare-facility/healthcare-facility.reducer';
import {IHealthcareFacilityCompact} from 'app/shared/model/healthcare-facility-compact.model';

export interface IPaymentProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {
}

export const Payment = (props: IPaymentProps) => {
  const {getLabel} = useRegionLabels();
  const [filterList, setFilterList] = useState({
    countryId: '',
    regionId: '',
    districtId: '',
    healthFacilityId: '',
    status: 'REQUESTED',
    activePage: 0,
    paymentId: '',
    driverName: '',
    sort: {sortOrder: 'asc', sortType: 'id'}
  });
  const [activeCountry, setCountry] = useState('');
  const [drivername, setDrivername] = useState('');
  const [regionList, setRegionList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [councilList, setCouncilList] = useState([]);
  const [healthFacilityList, setHealthFacilityList] = useState<IHealthcareFacilityCompact[]>([]);
  const [regionFilterList, setRegionFilterList] = useState([]);
  const [districtFilterList, setDistrictFilterList] = useState([]);
  const [healthFacilityFilterList, setHealthFacilityFilterList] = useState<IHealthcareFacilityCompact[]>([]);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedHealthFacility, setSelectedHealthFacility] = useState("");
  const [loadingFacilities, setLoadingFacilities] = useState(false);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState({
      hash: props.location.hash,
      key: props.location.key,
      pathname: props.location.pathname,
      search: "?page=1&sort=createdDateTime,asc",
      state: props.location.state
    }, ITEMS_PER_PAGE), props.location.search)
  );
  const [downloadLoader, setDownloadLoader] = useState(false);

  const {match, loading, RegCountries, paymentList, totalItems, userRoles, permissionSettings} = props;

  const permissionArray = permissionSettings.filter((item: any) => item.role === userRoles[0]);

  const getAllEntities = (countryId: string) => {
    const filterData = {...filterList}

    filterData.sort.sortOrder = paginationState.order === 'asc' ? 'desc' : 'asc';
    filterData.sort.sortType = paginationState.sort;

    filterData.activePage = paginationState.activePage - 1;
    filterData.countryId = countryId;
    filterData.regionId = filterList.regionId;
    filterData.districtId = filterList.districtId;
    filterData.healthFacilityId = filterList.healthFacilityId;


    props.getPaymentsByFilter(filterData);
    // props.getEntities(paginationState.activePage - 1, paginationState.itemsPerPage, `${paginationState.sort},${paginationState.order}`, countryId);

  };

  const sortEntities = (countryId: string) => {
    getAllEntities(countryId);
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }

  };

  useEffect(() => {
    if (filterList.countryId === '') {
      Promise.resolve(props.getAllByType("COUNTRY")).then((data: any) => {
        const filteredCountries = data.action.payload.data.filter(country => {
          return props.isAdmin ? 1 : country.id === props.userCountryId;
        })
        setCountryList([...filteredCountries]);
      });

      Promise.resolve(props.getAllByType("REGION")).then((data: any) => {
        setRegionList([...data.action.payload.data]);
        setRegionFilterList([...data.action.payload.data]);
      });

      Promise.resolve(props.getAllByType("DISTRICT")).then((data: any) => {
        setDistrictList([...data.action.payload.data]);
        setDistrictFilterList([...data.action.payload.data]);
      });

      Promise.resolve(props.getAllByType("COUNCIL")).then((data: any) => {
        setCouncilList([...data.action.payload.data]);
      });
    }
  }, [props.userCountryId]);

  // Fetch healthcare facilities when country is selected
  useEffect(() => {
    if (activeCountry) {
      setLoadingFacilities(true);
      Promise.resolve(props.getHealthcareFacilitiesCompact(activeCountry)).then((data: any) => {
        setHealthFacilityList([...data.action.payload.data]);
        setHealthFacilityFilterList([]);
        setLoadingFacilities(false);
      }).catch(() => {
        setLoadingFacilities(false);
      });
    }
  }, [activeCountry]);

  const fetchPayments = (page: number, sortField: string, sortOrder: string) => {
    setPaginationState({
      ...paginationState,
      activePage: page,
      sort: sortField,
      order: sortOrder,
    });

    const filterData = {...filterList};
    filterData.sort.sortOrder = sortOrder;
    filterData.sort.sortType = sortField;
    filterData.activePage = page - 1;
    filterData.countryId = filterList.countryId || activeCountry;
    props.getPaymentsByFilter(filterData);

    const endURL = `?page=${page}&sort=${sortField},${sortOrder}`;
    props.history.push(`${props.location.pathname}${endURL}`);
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  const sort = p => () => {
    const newOrder = paginationState.order === 'asc' ? 'desc' : 'asc';
    fetchPayments(1, p, newOrder);
  };

  const handlePagination = currentPage => {
    fetchPayments(currentPage, paginationState.sort, paginationState.order);
  };

  const handleSearch = () => {
    if (!activeCountry || !selectedRegion || !selectedDistrict) {
      return;
    }
    setSearchPerformed(true);
    fetchPayments(1, paginationState.sort, paginationState.order);
  };

  // console.log("activepagecred", paginationState, props, filterList)

  const regCountriesList = RegCountries.filter((ele) => {
    return props.isAdmin ? 1 : ele.id === activeCountry;
  })

  const countryName = (id: string) => {
    const foundCountry = regCountriesList.find(country => country.id === id);
    return foundCountry?.name
  }

  const getSortIcon = (field: string) => {
    if (paginationState.sort === field) {
      return paginationState.order === 'asc' ? 'sort-up' : 'sort-down';
    }
    return 'sort';
  };

  const handleFilterChange = (field: string, value: string) => {
    const updates: any = {[field]: value};

    // Handle cascading filter resets and dependent state updates
    if (field === 'countryId') {
      setCountry(value);
      updates.regionId = '';
      updates.districtId = '';
      updates.healthFacilityId = '';

      const newFilteredRegion = regionList.filter(region => region.parentId === value);
      setRegionFilterList([...newFilteredRegion]);

      setSelectedRegion("");
      setSelectedDistrict("");
      setSelectedHealthFacility("");
      setDistrictFilterList([]);
      setHealthFacilityFilterList([]);
      setLoadingFacilities(false);
    } else if (field === 'regionId') {
      setSelectedRegion(value);
      updates.districtId = '';
      updates.healthFacilityId = '';

      const newFilteredDistrict = districtList.filter(district => district.parentId === value);
      setDistrictFilterList([...newFilteredDistrict]);

      setSelectedDistrict("");
      setSelectedHealthFacility("");
      setHealthFacilityFilterList([]);
    } else if (field === 'districtId') {
      setSelectedDistrict(value);
      updates.healthFacilityId = '';

      const newFilteredHealthFacility = healthFacilityList.filter(facility =>
        facility.districtId === value
      );
      setHealthFacilityFilterList([...newFilteredHealthFacility]);

      setSelectedHealthFacility("");
    } else if (field === 'healthFacilityId') {
      setSelectedHealthFacility(value);
    }

    setFilterList({...filterList, ...updates});
    setSearchPerformed(false);
  };

  const downloadPayment = async () => {
    // call API here
    console.log("DOWNLOAD PAYMENTS API CALLED", filterList.countryId, filterList.status);
    setDownloadLoader(true);

    let downloadUrl = `api/downloadPaymentsByFilter?countryId=${filterList.countryId}`;
    if (filterList.status) downloadUrl += `&status=${filterList.status}`;
    if (filterList.regionId) downloadUrl += `&regionId=${filterList.regionId}`;
    if (filterList.districtId) downloadUrl += `&districtId=${filterList.districtId}`;
    if (filterList.healthFacilityId) downloadUrl += `&healthFacilityId=${filterList.healthFacilityId}`;
    if (filterList.paymentId) downloadUrl += `&paymentId=${filterList.paymentId}`;
    if (filterList.driverName) downloadUrl += `&driverName=${filterList.driverName}`;

    await axios.get(downloadUrl, {
      responseType: 'blob'
    }).then((response: any) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filterList.status} Payments - ${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      setDownloadLoader(false);
    }).catch(error => {
      console.log("ERROR", error);
      setDownloadLoader(false);
    });
  }

  return (
    <div>
      <h2 id="payment-heading">
        Payments
        {((permissionArray.length > 0 && permissionArray[0].permissions.includes("PAYMENT_EXPORT")) || props.isAdmin)
          && (<Button className="btn btn-primary float-right download-payments" id="download-payments"
                      onClick={() => downloadPayment()}
                      disabled={downloadLoader}
          >
            {downloadLoader ? <Loader type="TailSpin" color="#FFFFFF" height={15} width={15}> Loading...</Loader> :
              <span><FontAwesomeIcon icon="save"/>
                &nbsp; Download</span>}
          </Button>)}
      </h2>
      <AvForm model={{}}>
        <Row>
          <Col md="6">
            <AvGroup>
              <Label id="typeLabel" for="payment-country">
                Country *
              </Label>
              {countryList && (
                <AvInput
                  id="payment-country"
                  type="select"
                  className="form-control"
                  name="country"
                  value={activeCountry}
                  onChange={(event: any) => handleFilterChange('countryId', event.target.value)}
                >
                  <option value={""}>Select Country</option>
                  {countryList.length > 0 &&
                    countryList.sort((a, b) => a.name.localeCompare(b.name))?.map(country => {
                      return (
                        <option value={country.id} key={'country-' + country.name}>
                          {country.name}
                        </option>
                      );
                    })}
                </AvInput>
              )}
            </AvGroup>
          </Col>

          <Col md="6">
            <AvGroup>
              <Label for="payment-regions">{getLabel(RegionDescriptionType.REGION)} *</Label>
              <AvInput
                id="payment-regions"
                type="select"
                className="form-control"
                name="paymentRegion"
                onChange={(e: any) => handleFilterChange('regionId', e.target.value)}
                value={selectedRegion}
                disabled={!activeCountry}
              >
                <option value={""}>Select {getLabel(RegionDescriptionType.REGION)}</option>
                {regionFilterList && activeCountry &&
                  regionFilterList.sort((a, b) => a.name.localeCompare(b.name)).map(region => (
                    <option value={region.id} key={region.id}>
                      {region.name}
                    </option>
                  ))}
              </AvInput>
            </AvGroup>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <AvGroup>
              <Label for="payment-districts">{getLabel(RegionDescriptionType.DISTRICT)} *</Label>
              <AvInput
                id="payment-districts"
                type="select"
                className="form-control"
                name="paymentDistrict"
                onChange={(e: any) => handleFilterChange('districtId', e.target.value)}
                value={selectedDistrict}
                disabled={!selectedRegion}
              >
                <option value={""}>Select {getLabel(RegionDescriptionType.DISTRICT)}</option>
                {districtFilterList && selectedRegion &&
                  districtFilterList.sort((a, b) => a.name.localeCompare(b.name)).map(district => (
                    <option value={district.id} key={district.id}>
                      {district.name}
                    </option>
                  ))}
              </AvInput>
            </AvGroup>
          </Col>

          <Col md="6">
            <AvGroup>
              <Label for="payment-health-facilities">
                Health Facility {loadingFacilities && '(Loading...)'}
              </Label>
              <AvInput
                id="payment-health-facilities"
                type="select"
                className="form-control"
                name="paymentHealthFacility"
                onChange={(e: any) => handleFilterChange('healthFacilityId', e.target.value)}
                value={selectedHealthFacility}
                disabled={!selectedDistrict}
              >
                <option value={""}>All</option>
                {healthFacilityFilterList && selectedDistrict &&
                  healthFacilityFilterList.sort((a, b) => a.name.localeCompare(b.name)).map(facility => (
                    <option value={facility.id} key={facility.id}>
                      {facility.name}
                    </option>
                  ))}
              </AvInput>
            </AvGroup>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <AvGroup>
              <Label for="status-filter">Status</Label>
              <AvInput
                onChange={(event) => handleFilterChange('status', event.target.value)}
                id="status-filter"
                type="select"
                className="form-control"
                name={'status-filter'}
                value={filterList.status}
              >
                <option value='' key='ALL'>ALL</option>
                {Object.values(PaymentStatus).map(s => (<option value={s} key={s}>{s}</option>))}
              </AvInput>
            </AvGroup>
          </Col>

          <Col md="6">
            <AvGroup>
              <Label for="payment-id-filter">Search By Payment Id</Label>
              <AvInput
                id="payment-id-filter"
                type="input"
                className="form-control"
                name={'payment-id-filter'}
                value={filterList.paymentId}
                onChange={(e) => handleFilterChange('paymentId', e.target.value)}
              >
              </AvInput>
            </AvGroup>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <AvGroup>
              <Label for="driver-name-filter">Search by Driver Name (Community/Ambulance)</Label>
              <AvInput
                id="driver-name-filter"
                type="input"
                className="form-control"
                name={'driver-name-filter'}
                value={filterList.driverName}
                onChange={(e) => handleFilterChange('driverName', e.target.value)}
              >
              </AvInput>
            </AvGroup>
          </Col>
          <Col md="6">
            <Label>&nbsp;</Label>
            <div>
              <Button color="primary" onClick={handleSearch}
                      disabled={!activeCountry || !selectedRegion || !selectedDistrict}>
                <FontAwesomeIcon icon="search"/>
                &nbsp; Search
              </Button>
            </div>
          </Col>
        </Row>

        {!activeCountry || !selectedRegion || !selectedDistrict ? (
          <div className="alert alert-warning mb-3">Please select Country, {getLabel(RegionDescriptionType.REGION)},
            and {getLabel(RegionDescriptionType.DISTRICT)} to search</div>
        ) : null}

      </AvForm>

      <div className="table-responsive">
        {/* {console.log("PAYMENTS LISTS",paymentList.filter((item:any) => item?.countryId === activeCountry), paymentList && paymentList.filter((item:any) => item?.countryId === activeCountry).length > 0, activeCountry)} */}
        {activeCountry && selectedRegion && selectedDistrict && paymentList && paymentList.filter((item: any) => item?.countryId === activeCountry).length > 0 ? (
          <Table responsive>
            <thead>
            <tr>
              <th style={{

                width: "15%",
                wordBreak: "break-all"

              }} className="hand" onClick={sort('id')}>ID <FontAwesomeIcon icon={getSortIcon('id')}/></th>
              <th style={{

                width: "10%",
                wordBreak: "break-all"

              }} className="hand" onClick={sort('createdDateTime')}>Created Date <FontAwesomeIcon
                icon={getSortIcon('createdDateTime')}/></th>
              <th style={{

                width: "10%",
                wordBreak: "break-all"

              }}>Country
              </th>
              <th style={{

                width: "10%",
                wordBreak: "break-all"

              }}>Driver
              </th>
              <th style={{

                width: "10%",
                wordBreak: "break-all"

              }}>Status
              </th>
              <th style={{

                width: "10%",
                wordBreak: "break-all"

              }}>Distance
              </th>
              {/* <th style={{

                  width: "10%",
                  wordBreak: "break-all"

                }}>Duration (Minutes)</th> */}
              <th style={{

                width: "10%",
                wordBreak: "break-all"

              }}>Cost
              </th>
              <th style={{

                width: "10%",
                wordBreak: "break-all"

              }}>Incident
              </th>
              <th style={{

                width: "15%",
                wordBreak: "break-all"

              }} className="hand" onClick={sort('processingError')}>
                Processing Error <FontAwesomeIcon icon={getSortIcon('processingError')}/></th>


            </tr>
            </thead>
            <tbody>
            {paymentList.filter((item: any) => item?.countryId === activeCountry).map((payment, i) => (
              <tr key={`payment-${i}`}>
                <td>
                  <Button tag={Link} to={`${match.url}/${payment.id}`} color="link" size="sm">
                    {payment.id}
                  </Button>
                </td>
                <td>
                  {convertDateTimeFromServer(payment.createdDateTime)}
                </td>
                <td>
                  {countryName(payment.countryId)}
                </td>
                <td>
                  {payment.journey?.driver ? payment.journey?.driver?.firstName : payment.journey?.ambulance?.driverFirstName}
                  &nbsp;
                  {payment.journey?.driver ? payment?.journey?.driver?.lastName : payment.journey?.ambulance?.driverLastName}
                  &nbsp;:
                  {payment.journey?.driver ? ' Community Driver' : ' Ambulance'}
                </td>
                <td>
                  {payment.status}
                </td>
                <td>
                  {payment.journey?.totalDistance} km
                </td>
                {/* <td>
                    {displaySecondsAsHoursMinutes(payment.journey?.totalDurationSeconds)}
                  </td> */}
                <td>
                  {fromCents(typeof payment.overrideAmount !== 'undefined' && payment.overrideAmount ? payment.overrideAmount : typeof payment.journey?.totalCost !== 'undefined' && payment.journey.totalCost ? payment.journey.totalCost : 0)}
                </td>
                <td>
                  {payment.journey?.incidentReportDescription || 'No Incidents'}
                </td>
                <td>
                  {payment.processingError}
                </td>


              </tr>
            ))}
            </tbody>
          </Table>
        ) : (
          !loading && searchPerformed && paymentList && paymentList.length === 0 &&
          <div className="alert alert-warning">No Payments found</div>
        )}
      </div>

      {props.totalItems && (!drivername) ? (
        <div
          className={paymentList && paymentList.filter((item: any) => item?.countryId === activeCountry).length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems}
                          itemsPerPage={paginationState.itemsPerPage}/>
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={props.totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

const mapStateToProps = ({payment, authentication, permissionSettings}: IRootState) => ({
  paymentList: payment.payments,
  loading: payment.loading,
  totalItems: payment.totalItems,
  RegCountries: authentication.countries,
  userCountryId: authentication.userCountryId,
  isAdmin: hasAnyPermission(authentication.account.roles, ['ADMIN']),
  userRoles: authentication.account.roles,
  permissionSettings: permissionSettings.settings
});

const mapDispatchToProps = {
  getPayments,
  getPaymentsByFilter,
  searchByPaymentId,
  getPaymentsByDriverName,
  getAllByType,
  getHealthcareFacilitiesCompact
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
